// @ts-check

import { getCurrency, setCurrency } from "../utilities/numbers";
import { get, getAll } from "../utilities/querySelector";

jQuery(function () {

  const header = /** @type {HTMLElement}*/ (document.getElementById('site-header'));
  const bun = get('.burgerBun', header);

  setHeaderScrollState();
  window.addEventListener('scroll', setHeaderScrollState, { passive: true });
  window.addEventListener('resize', setHeaderScrollState, { passive: true });

  bun?.addEventListener('click', function () {
    bun.classList.toggle('open');
    get('.menu-mobile-menu-container', header)?.classList.toggle("open");
  });

  getAll('.menu-mobile-menu-container a', header).forEach(navLink => {
    navLink.addEventListener('click', function () {
      bun?.classList.remove('open');
      get('.menu-mobile-menu-container', header)?.classList.remove("open");
    });

  });

  function setHeaderScrollState() {
    if (window.scrollY > 10) {
      header.classList.add('scroll');
    } else {
      header.classList.remove('scroll');
    }
  }

});